module.exports = __webpack_public_path__ + "static/media/MTD Online uses Curuflow telemedicine platform.a7b0304e.webp";